import { WorkSpaceConstants } from './WorkSpace.constants';

var initialState = {
  initialDashboardList: {
    list: {}
  },
  activeDashboards: [],
  selectedDashboard: '',
  selectedDashboardConfig: {},
  appliedFilters: {},
  chartTemplates: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Initial dashboards
    case WorkSpaceConstants.GET_WORKSPACE_INITIAL_CONFIG_REQUEST:
      return {
        ...state,
        initialDashboardList: { loading: true, error: false }
      };

    case WorkSpaceConstants.GET_WORKSPACE_INITIAL_CONFIG_SUCCESS:
      return {
        ...state,
        initialDashboardList: {
          loading: false,
          error: false,
          list: action.payload
        }
      };

    case WorkSpaceConstants.GET_WORKSPACE_INITIAL_CONFIG_FAILED:
      return {
        ...state,
        initialDashboardList: { loading: false, error: true }
      };

    // Initial dashboard details
    case WorkSpaceConstants.GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_REQUEST:
      return {
        ...state,
        selectedDashboardConfig: { loading: true, error: false }
      };

    case WorkSpaceConstants.GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...state,
        selectedDashboardConfig: action.payload
      };

    case WorkSpaceConstants.GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_FAILED:
      return {
        ...state,
        selectedDashboardConfig: { loading: false, error: true }
      };

    // update selected
    case WorkSpaceConstants.UPDATE_SELECTED_DASHBOARD:
      return {
        ...state,
        selectedDashboard: action.payload
      };

    // update Active dashboards
    case WorkSpaceConstants.UPDATE_ACTIVE_DASHBOARD:
      return {
        ...state,
        activeDashboards: action.payload
      };

    //add chart / update visualisation_set
    case WorkSpaceConstants.ADD_CHART_TO_VISUALISATION_SET:
      return {
        ...state,
        selectedDashboardConfig: {
          ...state.selectedDashboardConfig,
          visualisation_set: action.payload
        }
      };

    // update Applied filter initial list
    case WorkSpaceConstants.INITIAL_APPLIED_FILTERS:
      return {
        ...state,
        appliedFilters: action.payload
      };

    // update Applied filter initial list
    case WorkSpaceConstants.SET_CHART_TEMPLATES:
      return {
        ...state,
        chartTemplates: action.payload
      };

    default:
      return state;
  }
}
